import axios from "axios";
import { API_URL, WEB_URL } from "../../constants";

export const GetFacebookMedia = async (ApiStatus, mediaType, after) => {
    ApiStatus({ isLoader: true, isError: false, data: null });
    const token = sessionStorage.getItem('LOGIN_TOKEN');

    try {
        let res = await axios.get(WEB_URL + `fblogin/${mediaType}/?u_token=` + token + (after ? `&after=${after}` : ''), {
            headers: {
                'Authorization': "",
                'Accept':'application/json; charset=UTF-8',
            }
        });
        ApiStatus({ isLoader: false, isError: false, data: res.data });
    } catch (err) {
        ApiStatus({ isLoader: false, isError: true, data: null });
    }

}